"use client";
import React from "react";
import * as RadixPopover from "@radix-ui/react-popover";

function Popover(props: RadixPopover.PopoverProps) {
  return (
    <RadixPopover.Root {...props}>
      {props.children}
    </RadixPopover.Root>
  );
}

function Trigger(props: RadixPopover.PopoverTriggerProps) {
  return <RadixPopover.Trigger {...props} />;
}

interface PopoverContentProps extends RadixPopover.PopoverContentProps {
  arrow?: boolean;
}

function Content(
  props: PopoverContentProps
) {
  return (
    <RadixPopover.Portal>
      <RadixPopover.Content
        {...props}
        className="rounded-md bg-light shadow-elevation-300 z-[50] focus:shadow-elevation-400 will-change-[transform,opacity] data-[state=open]:data-[side=top]:animate-slideDownAndFade data-[state=open]:data-[side=right]:animate-slideLeftAndFade data-[state=open]:data-[side=bottom]:animate-slideUpAndFade data-[state=open]:data-[side=left]:animate-slideRightAndFade"
      >
        {props.children}
        {props.arrow && <RadixPopover.Arrow className="fill-light w-[16px] h-[6px]" />}
      </RadixPopover.Content>
    </RadixPopover.Portal>
  );
}

function Close(
  props: RadixPopover.PopoverCloseProps
) {
  return (
    <RadixPopover.Close {...props}>
      {props.children}
    </RadixPopover.Close>
  )
}

Popover.Trigger = Trigger;
Popover.Content = Content;
Popover.Close = Close;
export default Popover;